import { render } from "./TextAIMiniGuide.vue?vue&type=template&id=0e303d19"
import script from "./TextAIMiniGuide.vue?vue&type=script&lang=js"
export * from "./TextAIMiniGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__